import { Heart } from 'lucide-react';
import { Button } from './ui/button';

const STRIPE_DONATION_LINK = 'https://buy.stripe.com/9B66oH60U7qig3N3fB0Ba03';

export const Footer = ({ t }) => {
  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Copyright */}
          <p className="text-sm text-muted-foreground text-center sm:text-left">
            {t('footer_copyright')}
          </p>

          {/* Donation Button */}
          <div className="flex items-center gap-3">
            <span className="text-sm text-muted-foreground">
              {t('footer_support')}
            </span>
            <Button
              asChild
              variant="default"
              size="sm"
              className="gap-2"
              data-testid="donate-button"
            >
              <a 
                href={STRIPE_DONATION_LINK} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Heart className="h-4 w-4" />
                {t('footer_donate')}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
};
